export default "__VITE_ASSET__BUmSqHsF__"